import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type TitleOfferFragment = {
	__typename?: 'Offer';
	id: string;
	presentationType: Types.PresentationType;
	monetizationType: Types.MonetizationType;
	newElementCount?: number | null;
	retailPrice?: string | null;
	retailPriceValue?: number | null;
	userLocalCurrency?: string | null;
	retailPriceConverted?: string | null;
	currency?: string | null;
	lastChangeRetailPriceValue?: number | null;
	type: Types.OfferType;
	country: any;
	standardWebURL?: string | null;
	preAffiliatedStandardWebURL?: string | null;
	streamUrl?: string | null;
	streamUrlExternalPlayer?: string | null;
	elementCount?: number | null;
	availableTo?: any | null;
	subtitleLanguages: Array<any>;
	videoTechnology: Array<Types.VideoTechnology>;
	audioTechnology: Array<Types.AudioTechnology>;
	audioLanguages: Array<any>;
	updatedAt?: any | null;
	mediaDealId?: number | null;
	package: {
		__typename?: 'Package';
		id: string;
		packageId: number;
		clearName: string;
		shortName: string;
		technicalName: string;
		icon: string;
		iconWide: string;
		planOffers: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	};
	plans: Array<{
		__typename?: 'PackagePlanOffer';
		title?: string | null;
		retailPrice?: string | null;
		isTrial?: boolean | null;
		durationDays?: number | null;
		retailPriceValue?: number | null;
		retailPriceConverted?: string | null;
		children: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
		}>;
	}>;
};

export type TitleOfferLightFragment = {
	__typename: 'Offer';
	id: string;
	monetizationType: Types.MonetizationType;
	presentationType: Types.PresentationType;
	standardWebURL?: string | null;
	package: {
		__typename: 'Package';
		id: string;
		packageId: number;
		clearName: string;
		shortName: string;
		icon: string;
		iconWide: string;
		technicalName: string;
	};
};

export type FastOfferFragment = {
	__typename?: 'Offer';
	availableTo?: any | null;
	availableFromTime?: any | null;
	availableToTime?: any | null;
	id: string;
	presentationType: Types.PresentationType;
	monetizationType: Types.MonetizationType;
	newElementCount?: number | null;
	retailPrice?: string | null;
	retailPriceValue?: number | null;
	userLocalCurrency?: string | null;
	retailPriceConverted?: string | null;
	currency?: string | null;
	lastChangeRetailPriceValue?: number | null;
	type: Types.OfferType;
	country: any;
	standardWebURL?: string | null;
	preAffiliatedStandardWebURL?: string | null;
	streamUrl?: string | null;
	streamUrlExternalPlayer?: string | null;
	elementCount?: number | null;
	subtitleLanguages: Array<any>;
	videoTechnology: Array<Types.VideoTechnology>;
	audioTechnology: Array<Types.AudioTechnology>;
	audioLanguages: Array<any>;
	updatedAt?: any | null;
	mediaDealId?: number | null;
	package: {
		__typename?: 'Package';
		id: string;
		packageId: number;
		clearName: string;
		shortName: string;
		technicalName: string;
		icon: string;
		iconWide: string;
		planOffers: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
			retailPriceConverted?: string | null;
			children: Array<{
				__typename?: 'PackagePlanOffer';
				title?: string | null;
				retailPrice?: string | null;
				isTrial?: boolean | null;
				durationDays?: number | null;
				retailPriceValue?: number | null;
			}>;
		}>;
	};
	plans: Array<{
		__typename?: 'PackagePlanOffer';
		title?: string | null;
		retailPrice?: string | null;
		isTrial?: boolean | null;
		durationDays?: number | null;
		retailPriceValue?: number | null;
		retailPriceConverted?: string | null;
		children: Array<{
			__typename?: 'PackagePlanOffer';
			title?: string | null;
			retailPrice?: string | null;
			isTrial?: boolean | null;
			durationDays?: number | null;
			retailPriceValue?: number | null;
		}>;
	}>;
};

export const TitleOfferLightFragmentDoc = gql`
	fragment TitleOfferLight on Offer {
		id
		monetizationType
		presentationType
		standardWebURL
		package {
			id
			packageId
			clearName
			shortName
			icon(profile: S100)
			iconWide(profile: S160)
			technicalName
			__typename
		}
		__typename
	}
`;
export const TitleOfferFragmentDoc = gql`
	fragment TitleOffer on Offer {
		id
		presentationType
		monetizationType
		newElementCount
		retailPrice(language: $language)
		retailPriceValue
		userLocalCurrency
		retailPriceConverted(language: $language)
		currency
		lastChangeRetailPriceValue
		type
		country
		package {
			id
			packageId
			clearName
			shortName
			technicalName
			icon(profile: S100)
			iconWide(profile: S160)
			planOffers(country: $country, platform: WEB) {
				title
				retailPrice(language: $language)
				isTrial
				durationDays
				retailPriceValue
				retailPriceConverted(language: $language)
				children {
					title
					retailPrice(language: $language)
					isTrial
					durationDays
					retailPriceValue
				}
			}
		}
		plans(platform: WEB) {
			title
			retailPrice(language: $language)
			isTrial
			durationDays
			retailPriceValue
			retailPriceConverted(language: $language)
			children {
				title
				retailPrice(language: $language)
				isTrial
				durationDays
				retailPriceValue
			}
		}
		standardWebURL
		preAffiliatedStandardWebURL
		streamUrl
		streamUrlExternalPlayer
		elementCount
		availableTo
		subtitleLanguages
		videoTechnology
		audioTechnology
		audioLanguages(language: $language)
		updatedAt
		mediaDealId
	}
`;
export const FastOfferFragmentDoc = gql`
	fragment FastOffer on Offer {
		...TitleOffer
		availableTo
		availableFromTime
		availableToTime
	}
	${TitleOfferFragmentDoc}
`;
